import React, {Component} from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Input from '../../components/layout/UI/Input/Input';
import './Registration.css';
import Dropdown from '../../components/layout/UI/Dropdown/Dropdown';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import constants from '../../config/constants';

class Registration extends Component {

  state={
    registration: 'CLOSED',
    addedStatus: false,
    registrationId: 0,
    errText:'',
    Player : {
      'referenceNo' : '',
      'firstName' : '',
	    'lastName' : '',
	    'age' : 0,
	    'streetAddr' : '',
	    'city' : '',	   
	    'zipcode' : 0,
      'contactNo' : 0,
      'emailId' :'',	    
      'zoneName' : '',
      'tshirtSize' : '',
      'teamId' : '',
      'status' : 'Pending',
      'remarks' : '',
      'stripeSessionId':''
    },
    isEmailAlreadyExists: false,
    isValid:false,
    show:false,    
    noftifyText:'',
    zoneData:'',
    tshirtSize:{
      1:'Small',
      2:'Medium',
      3:'Large',
      4:'XL',
      5:'XXL'
    }
  }

  componentDidMount(){
      fetch('https://x5qobu00wb.execute-api.us-east-1.amazonaws.com/pramukhcup/getZoneList')
      .then(results => {
        return results.json();
      }).then(resp => {
        this.setState({zoneData:resp});
      });
  }


render(){

           return (
            
            <div className='NewPlayer'>
              
              <div className="container-fluid">
                  <div className="card">
                      <div className="header">
                          <h4 className="title">Register</h4>
                          <p className="closeMessage" style={this.state.registration=='CLOSED' ? {} : { display: 'none' }}> Registration for {constants.tournament} 2023 is over. See you on tournament date March 25 and 26, 2023 at BAPS Edison Swaminarayan Temple.</p>
                      </div>
              
                      <form style={this.state.registration=='CLOSED' ?  { display: 'none' }:{}}>
                          <Grid>
                          <Row>
                            <Col xs={3} md={3}></Col>
                            <Col xs={5} md={4}>
                              <p class="red">{this.state.errText}</p>
                            </Col>
                            <Col xs={4} md={4}></Col>
                          </Row>
                          <Row>
                          <Col xs={1} md={1}></Col>
                          <Col xs={5} md={4}>
                            <Input id='firstName' placeHolderText='First Name'  inputtype='text' ctrlname='firstName' changed={this.changeHandler} validations={['required']}/>
                          </Col>
                          <Col xs={5} md={4}>
                            <Input id='lastName' placeHolderText='Last Name'  inputtype='text' ctrlname='lastName' changed={this.changeHandler} validations={['required']}/>
                          </Col>

                          </Row>
                          <Row>
                          <Col xs={1} md={1}></Col>
                          <Col xs={5} md={4}>
                            <Input id='contactNo' placeHolderText='Phone No' inputtype='number' changed={this.changeHandler} validations={['required', 'number']}/>
                          </Col>
                          <Col xs={5} md={4}>            
                            <Input id='emailId' placeHolderText='Email ID' inputtype='text' ctrlname='emailId' changed={this.changeHandler} validations={['required','email']}/>
                          </Col>
                          </Row>
                          <Row>
                          <Col xs={1} md={1}></Col>
                          <Col xs={3} md={2}>
                            <Input id='age' placeHolderText='Age' inputtype='number' ctrlname='age' changed={this.changeHandler} validations={['required', 'number']}/>
                          </Col>
                          <Col xs={7} md={6}>
                            <Input id='streetAddr' placeHolderText='Street Address:' inputtype='text' changed={this.changeHandler} validations={['required']}/>
                          </Col>
                          </Row>
                          <Row>
                          <Col xs={1} md={1}></Col>
                          <Col xs={5} md={4}>
                            <Input id='city' placeHolderText='City' inputtype='text' changed={this.changeHandler} validations={['required']}/>
                          </Col>
                            <Col xs={5} md={4}>
                            <Input id='zipcode' placeHolderText='Zipcode' inputtype='number' changed={this.changeHandler} validations={['required', 'number']}/>
                              </Col>
                          </Row>
                          <hr/>
                          <Row>
                          <Col xs={1} md={1}></Col>
                          <Col xs={5} md={4}>            
                            <Input lbltext='T-Shirt Size' inputtype='label'/>
                            <Input id='tshirtSize' lbltext='T-Shirt Size' inputtype='dropdown'ctrlname='tshirtSize' changed={this.changeHandler} data={this.state.tshirtSize}/>
                          </Col>
                          <Col xs={5} md={4}>
                            <Row><Input lbltext='Zone Name' inputtype='label'/></Row>
                            <Input id='zoneName' lbltext='Zone Name' inputtype='dropdown'ctrlname='zoneName' changed={this.changeHandler} data={this.state.zoneData}/>
                          </Col>
                          </Row>
                          <Row>
                            <Col xs={1} md={1}></Col>
                            <Col xs={10} md={8}>
                            
                            </Col>            
                          </Row>

                          <Row>
                            <Col xs={1} md={1}></Col>
                            <Col xs={11} md={10}>
                              &nbsp;
                            </Col>
                          </Row>       
                          <Row>    
                            <Col md={3} > </Col>       
                            <Col xs={12} md={8}>
                            <p className="paymentMessage">Please click below to make a secure payment on stripe and complete registration!</p>
                            </Col>
                          </Row>      
                          <Row>
                            <Col xs={4} md={4}>
                            </Col>
                            <Col xs={3} md={4}>
                              <button type="button" className="btn btn-success" onClick={this.savePlayer}>Proceed To Pay</button>
                            </Col>
                            <Col xs={3} md={4}>
                            </Col>
                          </Row>          
                          <Row>
                            <Col xs={1} md={1}></Col>
                            <Col xs={11} md={10}>
                              &nbsp;
                            </Col>
                          </Row>
                          </Grid>
                          </form>
                  
                  </div>
                  </div>
            </div>
      );
    


}


  changeHandler = (event) => {
        let inText = event.target.value;
        let inKey = event.target.id;
        // console.log(inKey+" : "+inText);      
        let updatedPlayer = this.state.Player; 
        if(inKey=='emailId' && inText){
          inText = inText.toLowerCase();
        }      
        updatedPlayer[inKey] = inText;
        
        this.setState({Player:updatedPlayer});
        // console.log(this.state.Player);
        if((inKey=='emailId'||inKey=='firstName'||inKey=='lastName')&&(this.state.Player.firstName!=''&&this.state.Player.lastName&&this.state.Player.emailId!='')){
          this.checkEmailAlreadyExists();
        }
      
  }

  checkEmailAlreadyExists = () => {
  fetch('https://e4x1efau0g.execute-api.us-east-1.amazonaws.com/pramukhcup/listPlayer', {
    method: 'post',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({"payload":{"Item":this.state.Player}})
  }).then(results => {            
    return results.json();
  }).then(resp => {
      if(resp && resp.length>0){        
        this.setState({isEmailAlreadyExists: true, errText:'Registration with this emailId already exists!'});
      } else{
        this.setState({isEmailAlreadyExists: false, errText:''});
      }
  });
}

replaceAll=(string, search, replace)=>{
  return string.split(search).join(replace);
}

savePlayer=()=>{

   let isEmailValid, isNameValid, isZipCodeValid , isContactNoValid, isAgeLimitValid = false;   
  //email validation
  const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (this.state.Player.emailId != '' && !reg.test(this.state.Player.emailId)){
      isEmailValid=false;
      this.setState({errText:'Please enter valid Email ID!'});
      return;
    }
    else{
      isEmailValid=true;
    }

    if(this.state.isEmailAlreadyExists){
      this.setState({isEmailAlreadyExists: true, errText:'Registration with this emailId already exists!'});
      return;
    }
   

    //number validation
    const re1 = /^[0-9\b]+$/;
    if (this.state.Player.zipcode != '' && !re1.test(this.state.Player.zipcode)) {
      isZipCodeValid=false;
      this.setState({errText:'Please enter valid Zipcode!'});
      return;
    }
    else{
      isZipCodeValid=true;
    }
    const re2 = /^[0-9\b]+$/;
    if (this.state.Player.contactNo != '' && !re2.test(this.state.Player.contactNo)) {
      isContactNoValid=false;
      this.setState({errText:'Please enter valid Contact No!'});
      return;
    }
    else{
      isContactNoValid=true;
    }

    //firstname lastname validation
    const re3 = /^[A-Za-z]+$/;
    // console.log(re3.test(this.state.Player.firstName));
    // console.log(re3.test(this.state.Player.lastName));
    if (this.state.Player.firstName != '' && !re3.test(this.state.Player.firstName)) {
      isNameValid=false;
      this.setState({errText:'Please enter valid firt Name!'});
      // console.log('enter valid first name');
      return;
    }
    else{
      isNameValid=true;
    }

    if (this.state.Player.lastName != '' && !re3.test(this.state.Player.lastName)) {
      isNameValid=false;
      this.setState({errText:'Please enter valid Last Name!'});
      // console.log('enter valid last name');
      return;
    }
    else{
      isNameValid=true;
    }

    if(this.state.Player.age&&this.state.Player.age<15){
        //  console.log('age is less than 15');
         this.setState({errText:"Sorry! player under 15 years of age is not allowed to participate in a tournament."});     
         return;             
    } else if(this.state.Player.age&&this.state.Player.age>60){
      // console.log('age is moret than 60');
      this.setState({errText:"Sorry! player above 60 years of age is not allowed to participate in a tournament."});     
      return;             
   }else {
        isAgeLimitValid = true;
    }

    if(this.state.Player.zoneName==''){
        let updatedPlayer = this.state.Player;
        let obj=this.state.zoneData;

        updatedPlayer['zoneName'] = obj[Object.keys(obj)[0]];
        this.setState({Player:updatedPlayer});
    }
    if(this.state.Player.tshirtSize==''){
        let updatedPlayer = this.state.Player;
        let obj=this.state.tshirtSize;

        updatedPlayer['tshirtSize'] = obj[Object.keys(obj)[0]];
        this.setState({Player:updatedPlayer});
    }
  if(this.state.Player.firstName!='' && this.state.Player.lastName!='' && this.state.Player.age!=''
  && this.state.Player.streetAddr!='' && this.state.Player.city!=''
  && this.state.Player.zipcode!='' && this.state.Player.contactNo!='' && this.state.Player.emailId!=''
  && this.state.Player.zoneName!='' 
  && isEmailValid && isNameValid && isZipCodeValid && isContactNoValid&&isAgeLimitValid){
     //console.log("validation passed");
     this.state.isValid=true;
   } else {
     this.state.isValid=false;    
     this.setState({errText:'Please enter all fields to register!'});    
   }

if(this.state.isValid){
          this.setState({addedStatus:false});

          let emailId = this.state.Player.emailId;
          if(emailId){
              emailId = emailId.replace("@","_at_");
              emailId = emailId.replace(".","_");                            
          }
         

          let clientRefId=this.state.Player.firstName+"_"+this.state.Player.lastName+"_"+this.state.Player.zoneName+"_"+emailId;
          clientRefId = clientRefId.substring(0,200); 
          clientRefId = this.replaceAll(clientRefId," ","");          
          // console.log(clientRefId);                
          let updatedPlayer = this.state.Player;          
          let base64ClientRefId = base64_encode(clientRefId.toLowerCase());          
          base64ClientRefId = this.replaceAll(base64ClientRefId,"=","");
          base64ClientRefId = this.replaceAll(base64ClientRefId,"+","");
          base64ClientRefId = this.replaceAll(base64ClientRefId,"/","");
          updatedPlayer['referenceNo'] = base64ClientRefId;
          this.setState({Player:updatedPlayer});

          let playerobj={"payload":{"Item":this.state.Player}};          
          // console.log(playerobj);
          this.setState({noftifyText:''});
          this.setState({errText:''});
          fetch('https://3qwgurow1h.execute-api.us-east-1.amazonaws.com/pramukhcup/player', {
            method: 'POST',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify(playerobj)
          }).then(results => {            
            return results.json();
          }).then(resp => {
            // console.log('resp : '+resp);
            //this.setState({noftifyText:resp.message});
            
            window.location.replace(resp.paymentLink+"?prefilled_email="+this.state.Player.emailId+"&client_reference_id="+(resp.uuId?resp.uuId:this.state.Player.referenceNo));
          }).catch( error => {
                      // console.log(error);
                      this.setState({errText:'Please contact your zone lead!'});
                    } );
          

      }
      else{
      }
}

   
  


}

export default Registration;



// WEBPACK FOOTER //
// ./src/pages/Registration/index.js